import { memo } from "react";
import { Typography, Box, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Search from "../../../assets/Images/search.png";

const NotFound = ({ handleReset }: any) => {
  const onTryAgain = () => {
    handleReset();
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        justifyItems: "center",
        width: "100%",
        height: "500px",
        borderRadius: "24px",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 5,
        }}
      >
        <img src={Search} alt="" width={200} height={200} />
        <Typography variant="h2">Không tìm thấy dữ liệu phù hợp</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#454654" }}>
            Hệ thống không thể tìm thấy kết quả định giá
          </Typography>
          <Typography sx={{ color: "#454654" }}>
            chính xác cho các thông số bạn vừa nhập. Vui lòng
          </Typography>
          <Typography sx={{ color: "#454654" }}>
            kiểm tra lại thông tin xe hoặc tải lên ảnh đăng kiểm xe.
          </Typography>
        </Box>
        <Button
          onClick={onTryAgain}
          variant="contained"
          startIcon={<RefreshIcon />}
        >
          Thử lại
        </Button>
      </Box>
    </Box>
  );
};

export default memo(NotFound);
